import React from 'react';
import { Controller } from 'react-hook-form';

import { ITextInputProps, TextInput } from '../../components';
import { FormError } from '../FormError';
import { FormField } from '../FormField';
import { FormLabel } from '../FormLabel';

import styles from './TextField.module.scss';

export interface ITextFieldProps extends ITextInputProps {
    name: string;
    label?: string;
    /** Optional element rendered on the right side of the label row (e.g. a "Forgot password?" link). */
    labelAction?: React.ReactNode;
}

export const TextField: React.FC<ITextFieldProps> = ({ id, name, label, labelAction, onBlur, ...inputProps }) => {
    return (
        <Controller
            name={name}
            render={({ field: { onChange, onBlur: onFieldBlur, ...fieldProps }, fieldState: { error } }) => (
                <FormField
                    labelSlot={
                        labelAction ? (
                            <div className={styles.labelRow}>
                                {label && <FormLabel htmlFor={id || name}>{label}</FormLabel>}
                                {labelAction}
                            </div>
                        ) : (
                            label && <FormLabel htmlFor={id || name}>{label}</FormLabel>
                        )
                    }
                    errorSlot={error && <FormError>{error?.message}</FormError>}
                >
                    <TextInput
                        id={id || name}
                        error={!!error}
                        onChange={(e) => {
                            const value = e.target.value;
                            onChange(value);
                        }}
                        onBlur={(e) => {
                            onFieldBlur();
                            onBlur?.(e);
                        }}
                        {...fieldProps}
                        {...inputProps}
                    />
                </FormField>
            )}
        />
    );
};
